import React from 'react';
export const ShareResults = ({ 
    fbShareUrl, 
    twitterShareUrl, 
    whatsappLink, 
    hideShareModal, 
    setClevertap 
})=>{
    return (
        <div class="quiz_popup_bg">
            <div class="popup_list">
                <button type="button" onClick={hideShareModal}> {"x"}</button>
                <ul>
                    <li>
                        <a 
                            href={fbShareUrl}
                            target="_blank"
                            onClick={() => {
                                setClevertap("web-facebook");
                            }}
                        >
                            <img src="/assets/images/facebook.svg" alt="" />
                            {"Facebook"}
                        </a>
                    </li>
                    <li>
                        <a 
                            href={twitterShareUrl}
                            target="_blank"
                            onClick={() => {
                                setClevertap("web-twitter");
                            }}
                        >
                            <img src="/assets/images/twitter.svg" alt="" />
                            {"Twitter"}
                        </a>
                    </li>
                    <li>
                        <a 
                            href={whatsappLink}
                            target="_blank"
                            onClick={() => {
                                setClevertap("web-whatsapp");
                            }}
                        >
                            <img src="/assets/images/whatsapp.svg" alt="" />
                            {"Whatsapp"}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    )
}